var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7345 15.999H15.3825L22.8705 7.99902L15.3825 -0.000976562H11.7345L16.5025 4.86302C17.3665 5.72702 18.0065 6.36702 18.4225 6.75102C17.4945 6.71902 16.6305 6.71902 15.7985 6.71902H0.310547V9.27902H15.7985C16.6625 9.27902 17.5265 9.27902 18.4225 9.24702L17.7825 9.82302L16.5345 11.039L11.7345 15.999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.1f90429881a221c55f67b5af6e68365a.svg";
export { ForwardRef as ReactComponent };